import { Button, Drawer as TmovDrawer } from '@tmov/design-system';
import PropTypes from 'prop-types';
import React from 'react';

import { useFiltro } from '../../../../../../contexts/FilaEmbarque/Filtro/hooks/useFiltro';
import { DrawerHeader } from '../components/DrawerHeader';
import { Filtros } from './Filtros';
import { ClearButton } from './Filtros/components/ClearButton';

export function DrawerFiltro({ transportadoras, onClose, visivel }) {
  const { filtro, setFieldDrawer, fetchFiltro } = useFiltro();
  const { filtrosDrawer } = filtro;

  const handleAplicarFiltros = () => {
    fetchFiltro(true);
    onClose();
  };

  const hasAnyFilter = () => {
    const hasStatus = filtrosDrawer.status.length > 0;
    const hasPlaca = filtrosDrawer.placa.length > 0;
    const hasCpf = filtrosDrawer.cpf.length > 0;
    const hasNomeMotorista = filtrosDrawer.nomeMotorista.length > 0;
    const hasTipoLote = filtrosDrawer.tipoLote.length > 0;
    const hasTransportadora = filtrosDrawer.idTransportadora.length > 0;

    return (
      hasStatus ||
      hasPlaca ||
      hasCpf ||
      hasTipoLote ||
      hasTransportadora ||
      hasNomeMotorista
    );
  };

  const setField = value => {
    setFieldDrawer({ ...value });
  };

  return (
    <TmovDrawer
      style={{
        width: '460px',
      }}
      header={
        <DrawerHeader
          headerTitle="Filtrar"
          headerDescription={<ClearButton />}
        />
      }
      active={visivel}
      updateActive={onClose}
      footer={
        <Button
          onClick={() => handleAplicarFiltros()}
          disabled={!hasAnyFilter()}
          style={{
            width: '100%',
          }}
        >
          Aplicar Filtros
        </Button>
      }
    >
      <div>
        <Filtros FiltrosData={{ setField, transportadoras }} />
      </div>
    </TmovDrawer>
  );
}

const transportadorasShape = PropTypes.shape({
  id: PropTypes.number,
  idTransportadora: PropTypes.number,
  razao: PropTypes.string,
});

DrawerFiltro.propTypes = {
  transportadoras: PropTypes.arrayOf(transportadorasShape),
  onClose: PropTypes.func,
  visivel: PropTypes.bool,
};

DrawerFiltro.defaultProps = {
  transportadoras: [],
  onClose: { setOpenDrawerFiltro: () => {} },
  visivel: false,
};
